import { createAction } from '@ngrx/store';

import { ClaimDashboardRequest, DashboardClaim } from './claim-dashboard.models';

export enum ClaimDashboardActionTypes {
  LOAD_CLAIM_DASHBOARD = '[ClaimDashboard] Load Dashboard Claims',
  LOAD_CLAIM_DASHBOARD_SUCCESS = '[ClaimDashboard] Load Dashboard Claims Success',
  LOAD_CLAIM_DASHBOARD_FAIL = '[ClaimDashboard] Load Dashboard Claims Error'
}

export const LoadClaimDashboard = createAction(
  ClaimDashboardActionTypes.LOAD_CLAIM_DASHBOARD,
  (payload: ClaimDashboardRequest) => ({
    payload
  })
);

export const LoadClaimDashboardSuccess = createAction(
  ClaimDashboardActionTypes.LOAD_CLAIM_DASHBOARD_SUCCESS,
  (payload: DashboardClaim[]) => ({
    payload
  })
);

export const LoadClaimDashboardFail = createAction(
  ClaimDashboardActionTypes.LOAD_CLAIM_DASHBOARD_FAIL,
  (payload: unknown) => ({
    //error
    payload
  })
);

export type ClaimDashboardAction =
  | ReturnType<typeof LoadClaimDashboard>
  | ReturnType<typeof LoadClaimDashboardSuccess>
  | ReturnType<typeof LoadClaimDashboardFail>;

export const fromClaimDashboardActions = {
  LoadClaimDashboard,
  LoadClaimDashboardSuccess,
  LoadClaimDashboardFail
};
